<script setup lang="ts">
import { computed, type HTMLAttributes } from 'vue';
import { TabsTrigger, type TabsTriggerProps } from 'reka-ui';
import { cn } from '@/lib/utils';
const props = defineProps<TabsTriggerProps & { class?: HTMLAttributes['class'] }>();
const forwarded = computed(() => {
  const { class: _class, ...rest } = props;
  return rest;
});
</script>

<template>
  <TabsTrigger
    v-bind="forwarded"
    :class="
      cn(
        'inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-sm px-3 py-1 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/30 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-card data-[state=active]:text-foreground data-[state=active]:shadow-[0_1px_2px_rgba(15,23,42,0.06)]',
        props.class
      )
    "
    ><slot
  /></TabsTrigger>
</template>
